const { createSeededRng } = require('../math/seed-rng');
const { validateCoreParams } = require('../math/validation');
const { calculateMetrics } = require('../math/stats');
const {
  LARGE_N_WARNING_TEXT,
  LARGE_N_WARNING_THRESHOLD
} = require('../constants/limits');

class BaseRandomizer {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  generate(params) {
    const normalizedParams = validateCoreParams(params);
    this.validateParams(normalizedParams);
    const resultParams = this.selectResultParameters(normalizedParams);
    const methodWarnings = [...(resultParams.methodWarnings || [])];

    if (normalizedParams.n > LARGE_N_WARNING_THRESHOLD) {
      methodWarnings.push(LARGE_N_WARNING_TEXT);
    }

    if (methodWarnings.length > 0) {
      resultParams.methodWarnings = methodWarnings;
    }

    const rng = createSeededRng(normalizedParams.seed);
    const sequence = this.randomize(rng, normalizedParams);
    sequence.forEach((patient) => {
      patient.arm = normalizedParams.armLabels[patient.armIndex] || `Arm ${patient.armIndex + 1}`;
    });
    const metrics = calculateMetrics(sequence, resultParams);

    return {
      sequence,
      seed: normalizedParams.seed,
      timestamp: new Date().toISOString(),
      metrics,
      algorithm: this.name,
      algorithmId: this.id,
      parameters: resultParams,
      version: 'randFlow v1.0'
    };
  }

  validateParams() {}

  selectResultParameters(params) {
    return {
      studyName: params.studyName || '',
      n: params.n,
      arms: params.arms,
      armLabels: params.armLabels,
      seed: params.seed,
      technique: params.technique
    };
  }

  randomize() {
    throw new Error('randomize() must be implemented by subclass');
  }

  getExplanation() {
    return '<p>No mathematical explanation is available for this technique yet.</p>';
  }

  buildAssignment(patientIndex, armIndex, extras = {}) {
    return {
      patientId: `P-${String(patientIndex + 1).padStart(5, '0')}`,
      armIndex,
      arm: `Arm ${armIndex + 1}`,
      sequenceOrder: patientIndex + 1,
      blockNumber: null,
      cluster: null,
      stratum: null,
      ...extras
    };
  }
}

module.exports = BaseRandomizer;
